import React from 'react';
import { ReactComponent as Rewind365Logo } from '../../../icons/rewind365-logo.svg';

const RewindLoginLogo: React.FC = () => {
    return <>
        <Rewind365Logo />
    </>
}

export default RewindLoginLogo;